import { AppBar, Box, Button, Container, CssBaseline, Paper, Stack, Toolbar, Typography, useTheme } from '@mui/material'
import React, { memo, useContext, useRef, useState } from 'react'
import { Table } from 'react-bootstrap'
import generatePDF from 'react-to-pdf';
import jsPDF from 'jspdf'
import 'jspdf-autotable';
import { PvMonitoringContext } from '../../context/PvMonitoringContext';
import ExportContent from '../ExportContent';
import Pagination from '../general/Pagination';
// import ExportContent from '../ExportContent';
// import Pagination from '../general/Pagination';
// import { PvMonitoringContext } from '../../context/PvMonitoringContext';

let Radiation;
function InverterTable({ radiationName, TableName, onHandleClose, onFullScreen, TableHead, TableData, onRefreshData, ValueOf1, ValueOf2, onChangeValueOF1, onChangeValueOF2 }) {
    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const { PvMnPostStringLoading } = useContext(PvMonitoringContext)
    const tableRef = useRef(null);

    // console.log('Table', TableData)
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(40);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = TableData.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(TableData.length / recordsPerPage)

    if (TableData?.length > 0) {
        Radiation = TableData[0]
    }





    function genPDF() {
        const textX = 20; // Adjust the X-coordinate as needed
        const textY = 20; // Adjust the Y-coordinate as needed
        const logoWidth = 50; // Adjust the logo width as needed
        const logoHeight = 30; // Adjust the logo height as needed
        const pdf = new jsPDF({ orientation: 'landscape', format: [300, 700] });

        // Add image dynamically
        const imgData = require('../../assets/img/logos/logo 2.png');

        // Get the width of the PDF document
        const pdfWidth = pdf.internal.pageSize.getWidth();

        // Calculate the X-coordinate to center the logo
        const logoX = (pdfWidth - logoWidth) / 2;

        // Add table content using autotable
        pdf.setFontSize(12);

        // Add the centered logo
        pdf.addImage(imgData, 'JPEG', logoX, textY + 5, logoWidth, logoHeight);

        // Add title centered on the page
        const title = ` ${TableName} ${ValueOf2}`;
        const titleWidth = pdf.getStringUnitWidth(title) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const titleX = (pdfWidth - titleWidth) / 2;

        pdf.text(title, titleX, textY + 5 + logoHeight + 10);

        pdf.autoTable({
            html: '#table-to-pdf', // specify the table ID
            startY: textY + 5 + logoHeight + 20, // Adjust the Y-coordinate as needed
            columnStyles: {
                2: { cellWidth: 50 }, // Adjust the cell width for the "Radiation Name" column
            },
        });

        // Save or download the PDF
        pdf.save(` ${TableName} To ${ValueOf2}.pdf`);
    }



    return (
        <>
            <CssBaseline />
            <Stack rowGap={spacing(1)}>
                <ExportContent
                    excelTableRef={tableRef.current}
                    onGenPdf={genPDF}
                    ExcelExportFileName={`${TableName} To ${ValueOf2}`}
                    title={TableName}
                    onFullScreen={onFullScreen}
                    filterContent={
                        <Stack flex={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                            <Box flex={1} columnGap={2} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                <input type='date' value={ValueOf1} className='searchField' style={{}} onChange={onChangeValueOF1} name='startDate' />
                                <Typography variant='body1' >To</Typography>
                                <input type='date' value={ValueOf2} className='searchField' style={{}} onChange={onChangeValueOF2} name='endDate' />
                                <Button onClick={onRefreshData} variant='contained' sx={{ color: 'background.default', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
                            </Box>
                        </Stack>
                    }
                />

                {


                    PvMnPostStringLoading ? (
                        <Typography variant='body2' textAlign={'center'}>Data Loading.......</Typography>
                    ) : (
                        currentRecords?.length <= 0 ? (
                            <Typography variant='body2' color={'error.main'} textAlign={'center'}>Data Not Found</Typography>
                        ) : (
                            <Box>
                                <div className='table-responsive'>
                                    <Table style={{}} id='table-to-pdf' ref={tableRef} striped bordered hover responsive>
                                        <thead style={{}}>
                                            <tr style={{ textAlign: 'center' }}>
                                                {
                                                    TableHead?.map((item, index) => {
                                                        return (
                                                            <th key={index} style={{ padding: 15, backgroundColor: "#FDF8E4", color: palette.primary.main }}>{item}</th>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                currentRecords?.map((item, index) => {
                                                    // console.log('data', item)
                                                    return (
                                                        <tr key={index}>
                                                            {TableHead?.map(key =>
                                                                <td key={key} style={{ textAlign: 'center', padding: spacing(1), whiteSpace: 'nowrap' }} align='center'>{item[key]}</td>
                                                            )}
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                                <Box
                                    sx={{ display: 'flex', justifyContent: 'end' }}
                                >
                                    <Pagination
                                        nPages={nPages}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    // scrollToBottom={scrollToBottom}
                                    />

                                </Box>
                            </Box>

                        )
                    )



                }




            </Stack>

        </ >
    )
}

export default memo(InverterTable)